'use client';

import { useQuery } from '@tanstack/react-query';
import apiService from '../services/api';
import { CONVERSATIONS_UNREAD_COUNT_QUERY_KEY } from '../lib/messagingQueryCache';
import { CONVERSATIONS_UNREAD_POLL_MS } from '../lib/pollingConstants';
import { resolvePollIntervalMs, type PollingEndpointKey } from '../lib/pollingManager';
import { usePollingGate } from './usePollingGate';

const ENDPOINT_KEY: PollingEndpointKey = 'conversations-unread';

type Options = {
  enabled?: boolean;
  /** Activer le poll (Layout : oui ; pages secondaires : non). */
  poll?: boolean;
};

export function useConversationsUnreadCount(options?: Options) {
  const enabled = options?.enabled ?? true;
  const poll = options?.poll ?? true;
  const { allowPolling } = usePollingGate();

  return useQuery({
    queryKey: CONVERSATIONS_UNREAD_COUNT_QUERY_KEY,
    queryFn: () => apiService.getConversationsUnreadCount(),
    enabled,
    retry: 0,
    staleTime: 30_000,
    refetchOnWindowFocus: false,
    refetchIntervalInBackground: false,
    refetchInterval: resolvePollIntervalMs(
      poll ? CONVERSATIONS_UNREAD_POLL_MS : false,
      ENDPOINT_KEY,
      allowPolling,
    ),
    meta: { pollingEndpoint: ENDPOINT_KEY },
  });
}
